import { render, staticRenderFns } from "./TotalCandidates.vue?vue&type=template&id=6fd799b8&scoped=true"
import script from "./TotalCandidates.vue?vue&type=script&lang=ts"
export * from "./TotalCandidates.vue?vue&type=script&lang=ts"
import style0 from "./TotalCandidates.vue?vue&type=style&index=0&id=6fd799b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd799b8",
  null
  
)

export default component.exports